/**
 * Detailed Listing slider using Swiper API.
 * Read more about the API at @link https://swiperjs.com/api/
 */
'use strict';

import { SwiperLoader } from '../swiper-loader';

let Swiper = undefined;
let Pagination = undefined;

class ListingBoxDetailedSlider {
  constructor(...args) {
    if (Swiper == undefined) {
      const loader = new SwiperLoader();
      loader.load().then((api) => {
        Swiper = api.Swiper;
        Pagination = api.Pagination;
        Swiper.use([Pagination]);
        this.initSlider(args);
      });
    } else {
      this.initSlider(args);
    }
  }
  initSlider(args) {
    let sliderContainer;
    let swiperParams;
    if (args.length === 1) {
      sliderContainer = args[0];
      swiperParams = {
        slidesPerView: 1,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 30,
          },
        },
        observer: true,
        observeParents: true
      }
    } else {
      [sliderContainer, swiperParams] = args;
    }
    return new Swiper(sliderContainer, swiperParams);
  }
}
export { ListingBoxDetailedSlider };